import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { initSentry } from "@/lib/sentry";
import "./styles/globals.css";
// Legacy design system z new-design/styles.css - port 1:1 (decyzja user 2026-06-07).
// Definiuje wszystkie custom design tokens (--accent, --tool, surfaces),
// typografie (DM Sans/Poppins), layout (app shell, sidebar, topbar) i komponenty
// (btn, card, modal, hub-card, tool screens). Wszystkie nasze komponenty
// uzywaja jego CSS classes.
import "./styles/legacy.css";
// Warstwa wyceny — raport i suwaki oceny lokalu, na tokenach z legacy.css.
import "./styles/valuation.css";

// Sentry init pierwszy - lapie nawet errors podczas hydration
initSentry();

// Force dark mode jako default (aplikacja studio = dark UI primary)
document.documentElement.classList.add("dark");

const root = document.getElementById("root");
if (!root) throw new Error("Brak #root w index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
